module.exports = __webpack_public_path__ + "img/Logo1.811e156e.png";